import { handleActions } from 'redux-actions';

import { FETCH_USERS, USERS_FILTER_SET, USERS_PAGE_SET } from '../../constants/Constants';

const initialState = { items: [], pagination: { page: 0, size: 50 }, filter: null };

export default handleActions(
  {
    [FETCH_USERS.SUCCESS]: (state, { payload: { items } }) => ({
      ...state,
      items
    }),
    [USERS_FILTER_SET]: (state, { payload }) => ({
      ...state,
      filter: payload,
      pagination: { ...state.pagination, page: 0 }
    }),
    [USERS_PAGE_SET]: (state, { payload: { page } }) => ({ ...state, pagination: { ...state.pagination, page } })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/entities/UsersReducer.js